import styled from "styled-components";
import Sizes from "../../Assets/Sizes";
import { Button } from "rmwc";

const SHORT_WIDTH_TEXT = 'calc(100% - 120px)';

const CenterContainer = styled.div`
  z-index: 1;
  text-align: center;
  width: 100%;
`;

const TextContainer = styled.div`
  width: 100%;
  padding-left: ${ Sizes.defaultPadding };
  padding-right: ${ Sizes.defaultPadding };
  flex-grow: 1;
  // margin-top: -150px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  *:focus {
    outline: none;
  }
`;

const FullWidthInput = styled.input`
  text-align: center;
  width: ${ p => p.short ? SHORT_WIDTH_TEXT : '100%' };
  border: none;
  border-bottom: 2px solid ${ p => p.theme.colors.primaryText };
  color: ${ p => p.theme.colors.primaryText };
  background-color: transparent;
  font-size: ${ Sizes.xlTextSize };
  box-shadow: none;
  border-radius: 0;
  direction: ltr;
  padding-bottom: ${ Sizes.smallMargin };

`;

const TypeNumberMessage = styled.div`
  width: ${ p => p.short ? SHORT_WIDTH_TEXT : '100%' };
  color: ${ p => p.theme.colors.primaryText };
  margin: ${ Sizes.mediumPadding };
  text-align: center;
`;

const TextWithIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SubmitButton = styled(Button)`
  --mdc-theme-primary: ${ p => p.theme.colors.primaryText };
  left: 0;
  bottom: 0;
  color: ${ p => p.theme.colors.primaryText };
  font-size: 20px;
  font-family: inherit;
  

  &[disabled] {
    opacity: 0.3;
    border-color: ${ p => p.theme.colors.primaryText };
    color: ${ p => p.theme.colors.primaryText };
  }
`;

const PhoneInputWrapper = styled.div`
  opacity: ${ p => p.visible ? 1 : 0.3 };
  transform: ${ p => p.visible ? 'none' : 'translateY(-120px)' };
  transition: all 500ms;
`;

export {
	CenterContainer,
	TextContainer,
	FullWidthInput,
	TypeNumberMessage,
	TextWithIconWrapper,
	SubmitButton,
	PhoneInputWrapper
}
